import { useTranslation } from 'react-i18next';
import CustomTabs from '../../components/tabs/CustomTabs';
import PriceAlertsTab from './components/tabs/PriceAlertsTab';
import PriceAlertsConfiguration from '../../pages/priceAlertsConfiguration/priceAlertsConfiguration';
import ProfitMarginAnalyticsTab from './components/tabs/ProfitMarginAnalyticsTab';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { PermissionEnum } from '../../enums/PermissionEnum';
import { usePermissions } from '../../hooks/usePermissions';

const AdvancedAnalysis = () => {
  const { t } = useTranslation(['advancedAnalysis']);
  const { hasPermission } = usePermissions();

  const tabs = [
    {
      label: t('priceAlertConfigurations'),
      key: '1',
      children: <PriceAlertsConfiguration />,
      isVisible: hasPermission([PermissionEnum.VIEW_CONFIG_ALERTS, PermissionEnum.CONFIG_ALERTS]),
    },
    {
      label: t('priceAlerts'),
      key: '2',
      children: <PriceAlertsTab />,
      isVisible: hasPermission(PermissionEnum.VIEW_ALERTS),
    },
    {
      label: t('profitMarginAnalytics'),
      key: '3',
      children: <ProfitMarginAnalyticsTab />,
      isVisible: hasPermission(PermissionEnum.VIEW_ANALYTICS),
    },
    /* {
      label: t('global&Agriculture'),
      key: '2',
      // children: <GlobalAndAgricultureTab />,
      children: <div className="my-10 text-2xl text-gray-400">{t('globalAgricultureCommingSoon')}</div>,
    },
    {
      label: t('cost&VariationAnalysis'),
      key: '3',
      // children: <CostAndVariationTab />,
      children: <div className="my-10 text-2xl text-gray-400">{t('costVariationCommingSoon')}</div>,
    },
    {
      label: t('operationalInsights'),
      key: '4',
      // children: <OperationalInsightsTab />,
      children: <div className="my-10 text-2xl text-gray-400">{t('operationalInsightCommingSoon')}</div>,
    }, */
  ].filter((tab) => tab.isVisible);

  return (
    <>
      <div className="mb-6 mt-12 w-full">
        <Breadcrumb separator=">">
          <Breadcrumb.Item><Link to='/analysis' className='navbar-option'>{t('analysisReport')}</Link></Breadcrumb.Item>
          <Breadcrumb.Item className='text-primary-font-color'>{t('pageHeading')}</Breadcrumb.Item>
        </Breadcrumb>
        <h1 className="text-[48px] font-normal text-headings-font-color sm:text-[64px]">
          {t('pageHeading')}
        </h1>
        <p className="text-base font-medium text-font-color">{t('pageDescription')}</p>
      </div>

      <section className="mt-3 w-full">
        {tabs.length > 0 && <CustomTabs defaultActiveKey={tabs[0].key} items={tabs} />}
      </section>
    </>
  );
};

export default AdvancedAnalysis;
